import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { animated as a, useSpring } from 'react-spring';
import { BsChevronDown } from 'react-icons/bs';
import { useMeasure } from 'react-use';
import { generate } from 'shortid';
import FlareGroup4 from '../assets/shapes/shape-group-4.svg';
import { CardOne, SEO, HalfByHalfSection } from '../components/_index';

const seoContent = {
  title: "Blog and Articles - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const HeroContentBlock = () => (
  <>
    <Heading
      as="h1"
      size="3xl"
      lineHeight="base"
      mt={10}
      mb={4}
    >
      <span className="highlight">Articles</span>
    </Heading>
    <Heading
      variant="sec"
      as="h2"
      size="lg"
      lineHeight="base"
      mb={10}
      maxWidth="600px"
    >
      {' '}
      We've put together a massive library of articles to help you along your
      home selling process.
      {' '}
    </Heading>
  </>
);

const FlareBlock = ({ img }) => (
  <Box
    zIndex="0"
    height="400px"
  >
    <Box
      className="height-500"
      position="relative"
      width="20rem"
      mx="auto"
      height="15rem"
    >
      <Box
        position="relative"
        mt={4}
        zIndex="-1"
      >
        <Box
          position="absolute"
          top="20%"
          left="20%"
        >
          <FlareGroup4 className="width-500 height-500" />
        </Box>
        <Box
          position="absolute"
          top="20%"
          left="20%"
        >
          <GatsbyImage
            className="width-300"
            alt="happy home buyers image"
            image={img}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);

const BlogPage = ({ data, location }) => {
  console.log('data', data);
  const flare = getImage(data.flareImage);
  return (
    <main>
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <Container
        maxW="container.xl"
        position="relative"
        display="flex"
        flexWrap="wrap"
        mt={6}
      >
        <HalfByHalfSection
          left={<HeroContentBlock />}
          right={<FlareBlock img={flare} />}
        />
      </Container>

      <Container maxW="container.xl">
        <Grid
          templateColumns="repeat(6, 1fr)"
          gap={6}
        >
          {data.posts.edges.map((p, i) => (
            <GridItem
              colSpan={{ base: 6, md: 2 }}
              rounded="md"
              backgroundColor="white"
              boxShadow="xl"
              key={generate()}
            >
              <Link to={p.node.uri}>
                <Box>
                  <Box>
                    <GatsbyImage
                      alt=""
                      image={
                        p.node.featuredImage.node.localFile.childImageSharp
                          .gatsbyImageData
                      }
                    />
                  </Box>
                  <Box p={{ base: 5, md: 10 }}>
                    <Heading
                      as="h4"
                      size="lg"
                    >
                      {p.node.title}
                    </Heading>
                    <Text
                      as="lg"
                      dangerouslySetInnerHTML={{
                        __html: p.node.excerpt,
                      }}
                    />
                  </Box>
                </Box>
              </Link>
            </GridItem>
          ))}
        </Grid>
      </Container>
    </main>
  );
};

export const query = graphql`
  query {
    posts: allWpPost(
      sort: { order: DESC, fields: date }
      filter: { status: { eq: "publish" } }
    ) {
      edges {
        next {
          uri
          title
        }
        previous {
          uri
          title
        }
        node {
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          content
          title
          excerpt
          uri
          status
          author {
            node {
              name
            }
          }
        }
      }
    }
    heroImage: file(relativePath: { eq: "illustrations/meeting.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    flareImage: file(relativePath: { eq: "people/bro.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default BlogPage;
